jQuery(document).ready(function ($) {

  $("iframe[data-src]").Lazy();
  
  let site_url = "";
  let isUserLoggedIn = false;

  if ($("#user_logged_id").length) {
    isUserLoggedIn = $("#user_logged_id")[0].value ? true : false;
  }

  if ($(".logoMob").length) {
    site_url = $(".logoMob")[0].href;
  }

  if (!$("body").hasClass("page-arecliente")) new WOW().init();

  if ($(".page-arecliente").length || $(".tax-documents_category").length) $("#filterSelect").selectric();

  if ($(".page-home").length) {
    $("#servicesSlider").owlCarousel({
      loop: false,
      margin: 0,
      nav: false,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      dots: true,
      dotElement: 'button role="button" aria-labelledby="Serviço {n}"',
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    });

    $("#clientsSlider").owlCarousel({
      center: false,
      loop: false,
      margin: 20,
      nav: false,
      autoWidth: false,
      autoplay: true,
      autoplayTimeout: 5000,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 4,
        },
        1000: {
          items: 6,
        },
      },
    });

    $("#depoimentsSlider").owlCarousel({
      center: false,
      loop: true,
      margin: 0,
      nav: false,
      // autoWidth: true,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      slideTransition: "ease",
      responsive: {
        0: {
          items: 1,
        },
        992: {
          center: true,
          items: 1,
        },
        1000: {
          items: 2,
        },
        1600: {
          items: 3,
        },
      },
    });
  }

  if ($(".page-about").length) {
    var loop = true;

    function addSiblingClass(event) {
      var index = event.item.index;
      var stage = event.relatedTarget.$stage;

      if (stage) {
        var items = stage.find(".owl-item");
        stage.find(".sibling").removeClass("sibling");
        stage.find(".mirror-active").removeClass("mirror-active");

        items.eq(index - 1).addClass("sibling");
        items.eq(index + 1).addClass("sibling");

        if (loop) {
          var mirrorActive = null;
          var clonedItems = Math.ceil(event.item.count / 2);
          clonedItems = clonedItems < 2 ? 2 : clonedItems;

          if (index === clonedItems - 1) {
            mirrorActive = items.length - (clonedItems + 1);
          } else if (index === items.length - (clonedItems + 1)) {
            mirrorActive = clonedItems - 1;
          }

          if (mirrorActive) {
            items.eq(mirrorActive - 1).addClass("sibling");
            items.eq(mirrorActive).addClass("mirror-active");
            items.eq(mirrorActive + 1).addClass("sibling");
          }
        }
      }
    }

    $("#carousel").owlCarousel({
      center: true,
      nav: false,
      dots: true,
      mouseDrag: false,
      pullDrag: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 1000,
      loop: loop,
      navSpeed: 1000,
      slideTransition: "ease",
      onInitialized: addSiblingClass,
      onChanged: addSiblingClass,
      navText: ["", ""],

      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 4,
        },
        1000: {
          items: 5,
        },
      },
    });
  }

  if ($(".page-services").length) {
    $("#carouselSevices").owlCarousel({
      center: true,
      loop: true,
      margin: 0,
      nav: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 1000,
      autoWidth: true,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      slideTransition: "ease",
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 5,
        },
      },
    });
  }

  $(this).on("click", ".actOpeMnu", function (e) {
    e.preventDefault();

    $(this).toggleClass("active");

    $("header nav").toggleClass("active");
  });

  if ($(window).width() < 1023) {
    $(".header-internal header nav ul").removeClass("wow");
  }

  $(this).on("click", ".wrapMnu .item > svg", function (e) {
    e.preventDefault();
    if ($(this).parent().find("> a").hasClass("open")) {
      $(this).parent().find("> a").removeClass("open");
      $(this).parent().find("> .wrapSubMnu").removeClass("active").slideToggle("fast");
    } else {
      $(this).parent().find("> a").addClass("open");
      $(this).parent().find("> .wrapSubMnu").slideToggle("fast").addClass("active");
    }
  });


  if ($(".login-modal").length) {
    $(".login-modal a").html(isUserLoggedIn ? "Área do cliente" : "Entrar");

    let userModalForm = `
    <div class='userModal'>
    <h3>Meu usuário</h3>
    <form action="${site_url}/wp-login.php" method="post">
      <input type="text" placeholder="Usuário" name="log" />
      <input type="password" placeholder="Senha" name="pwd" />
      <input type="hidden" name="redirect_to" value="${site_url}" />
      <input type="submit" value="Acessar" name="btn_submit" />
    </form>
    <a href="${site_url}/#contato" title="Entrar em contato">*Caso tenha esquecido os seus dados entre em contato conosco!</a>
    </div>`;

    if (!isUserLoggedIn) {
      $(".login-modal").append(userModalForm);
    } else {
      $(".login-modal a").attr("href", site_url + "/area-cliente");
    }
  }

  $(this).on("click", ".login-modal a", function () {
    if ($(".userModal").length) {
      $(".userModal").toggleClass("visible");
    }
  });

  //Go through each carousel on the page
  $('.owl-carousel').each(function () {
    //Find each set of dots in this carousel
    $(this).find('.owl-dot').each(function (index) {
      //Add one to index so it starts from 1
      $(this).attr('aria-label', index + 1);
    });
  });
});
